export function isEqualArrays(arrA, arrB) {
    if (arrA === arrB) {
        return true;
    }
    if (!arrA || !arrB) {
        return false;
    }
    const len = arrA.length;
    if (arrB.length !== len) {
        return false;
    }
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < len; i++) {
        if (arrA[i] !== arrB[i]) {
            return false;
        }
    }
    return true;
}
export function isIncludeArray(arrA, arrB) {
    return arrA.some(arrAItem => isEqualArrays(arrAItem, arrB));
}
export function getElementStyle(element) {
    if (!element) {
        return;
    }
    if (window.getComputedStyle) {
        return getComputedStyle(element, null);
    }
    return element.currentStyle;
}
export function isPureType(value) {
    return typeof value === 'string' || typeof value === 'number';
}
